import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useTranslation } from 'react-i18next';

function EditorMetas() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [isLoading, setIsLoading] = useState(false);

  // query params (si los usas en otra parte)
  const [code, setCode] = useState("");
  const [amount, setAmount] = useState("");
  const [backAccountID, setBackAccountID] = useState("");
  const [tParam, setTParam] = useState("");
  const [bParam, setBParam] = useState("");

  useEffect(() => {
    setCode(searchParams.get("code") || "");
    setAmount(searchParams.get("amount") || "");
    setBackAccountID(searchParams.get("backAccountID") || "");
    setTParam(searchParams.get("t") || "");
    setBParam(searchParams.get("b") || "");
  }, [location.search]);

  // productos
  const [products, setProducts] = useState([]); // { name, value, image }
  const [activeIndex, setActiveIndex] = useState(0);

  // formulario
  const [productName, setProductName] = useState("");
  const [productValue, setProductValue] = useState("");
  const [productImage, setProductImage] = useState(null); // File
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // cargar productos
  useEffect(() => {
    (async () => {
      const prods = await dataApi.getProducts();
      setProducts(prods);
    })();
  }, []);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
  };
  const handleNext = () => {
    setActiveIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
  };

  // inputs
  const handleNameChange = (e) => setProductName(e.target.value);
  const handleValueChange = (e) => setProductValue(e.target.value);
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProductImage(e.target.files[0]);
    }
  };

  // util: file -> base64
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  // CREAR o ACTUALIZAR
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      let imageBase64 = "";
      if (productImage) {
        imageBase64 = await toBase64(productImage);
      }

      if (isEditing && editIndex !== null) {
        // si no hay nueva imagen, conserva la existente
        const currentImg =
          imageBase64 || (products[editIndex] ? products[editIndex].image : "");
        const updatedProduct = {
          name: productName,
          value: productValue,
          image: currentImg,
        };
        const updated = await dataApi.updateProduct(editIndex, updatedProduct);
        if (!updated) throw new Error("update_failed");
        setProducts(updated);
        setActiveIndex(editIndex);
        toast.success('Actualizado');
      } else {
        const newProduct = {
          name: productName,
          value: productValue,
          image: imageBase64, // al crear sí pedimos imagen
        };
        const added = await dataApi.addProduct(newProduct);
        if (!added) throw new Error("create_failed");
        setProducts(added);
        setActiveIndex(added.length - 1);
        toast.success('Guardado');
      }

      // limpiar formulario
      setProductName("");
      setProductValue("");
      setProductImage(null);
      setIsEditing(false);
      setEditIndex(null);
    } catch (err) {
      if (isEditing) {
        toast.error('Error al actualizar');
      } else {
        toast.error('Error al guardar');
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Iniciar edición con el producto activo
  const handleStartEdit = () => {
    if (!products.length) return;
    const idx = activeIndex;
    const p = products[idx];
    setProductName(p?.name || "");
    setProductValue(p?.value || "");
    setProductImage(null); // la imagen se mantiene si no se sube otra
    setIsEditing(true);
    setEditIndex(idx);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditIndex(null);
    setProductName("");
    setProductValue("");
    setProductImage(null);
  };

  // borrar
  const handleDeleteProduct = async (index) => {
    setIsLoading(true);
    const updated = await dataApi.deleteProduct(index);
    if (updated) {
      setProducts(updated);
      setActiveIndex((prev) => {
        if (updated.length === 0) return 0;
        return prev >= updated.length ? updated.length - 1 : prev;
      });
      toast.success('Eliminado');
      // si borraste el que editabas, resetea
      if (isEditing && editIndex === index) handleCancelEdit();
    } else {
      toast.error('Error al eliminar');
    }
    setIsLoading(false);
  };

  return (
    <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
      <div className="cetes-background-inner">
        <div className="cetes-junior-header">
          <div className="info-header-cetes-junior">
            <div className="text-header-cetes">
              <h4 className="text-header-mayus">
                {t('meta_title')}<b>{t('meta_title_bold')}</b>
              </h4>
              <h4>{t('meta_subtitle')}</h4>
            </div>
          </div>
          <div className="logo_CETES_junior">
            <div className="logo logo-cetes">
              <img src={LogoCam} alt="Logo organización KidZania" />
            </div>
          </div>
        </div>

        {/* Formulario crear/editar */}
        <div className="registro-content">
          <form className="form-row-cetes input-lastname" onSubmit={handleSubmit}>
            <div className="input-txt-cetesJunior">
              <div className="text-descriptivo">
                <label htmlFor="product-name">{t('cms_name')}</label>
              </div>
              <input
                type="text"
                name="product-name"
                id="product-name"
                value={productName}
                onChange={handleNameChange}
                required
              />
            </div>

            <div className="input-txt-cetesJunior">
              <div className="text-descriptivo">
                <label htmlFor="product-value">{t('cms_value')}</label>
              </div>
              <input
                type="text"
                name="product-value"
                id="product-value"
                value={productValue}
                onChange={handleValueChange}
                required
              />
            </div>

            <div className="input-txt-cetesJunior">
              <div className="text-descriptivo">
                <label htmlFor="product-image">{t('cms_image')}</label>
              </div>
              <input
                type="file"
                name="product-image"
                id="product-image"
                onChange={handleImageChange}
                // imagen obligatoria SOLO al crear
                required={!isEditing}
                accept="image/*"
              />
            </div>

            <div className="registro-form-cetes-inner" style={{ display: 'flex', gap: 12 }}>
              <div className="btn-cetesJunior" style={{ margin: "20px auto 0 0" }}>
                <button type="submit" disabled={isLoading}>
                  {isEditing ? ('Actualizar') : ('Guardar')}
                </button>
              </div>
              {isEditing && (
                <button
                  type="button"
                  onClick={handleCancelEdit}
                  style={{ margin: "20px 0 0 0", background: '#999', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer' }}
                >
                  {'Cancelar'}
                </button>
              )}
            </div>
          </form>

          <div className="form-row-cetes input-lastname">
            <div className="text-descriptivo">
              <label>Las imágenes deben ser cuadradas, ejemplo: 512px x 512px</label>
            </div>
          </div>
        </div>

        {/* Carrusel */}
        <div className="registro-content">
          <div className="registro-form-cetes">
            <div className="registro-form-cetes-inner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', minHeight: '300px' }}>
              <button onClick={handlePrev} className='chevon_meta_prev' aria-label="Previous" disabled={products.length === 0}>
                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 6L9 12L15 18" stroke="#517769" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              <div className='carouselItem' >
                {products.length > 0 ? (
                  <>
                    {products[activeIndex]?.image && (
                      <img src={products[activeIndex].image} alt={`carousel-item-${activeIndex}`} style={{ maxHeight: 120 }} />
                    )}
                    <br />
                    <div className="price">{t('cms_name')}: {products[activeIndex].name}</div>
                    <div className="price">{t('cms_value')}: {products[activeIndex].value}</div>

                    <div style={{ marginTop: 10, display: 'flex', gap: 8, justifyContent: 'center' }}>
                      <button
                        style={{ background: '#2980b9', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer' }}
                        onClick={handleStartEdit}
                        disabled={isLoading}
                        type="button"
                      >
                        Editar
                      </button>

                      <button
                        style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', cursor: 'pointer' }}
                        onClick={() => handleDeleteProduct(activeIndex)}
                        disabled={isLoading}
                        type="button"
                      >
                        Eliminar
                      </button>
                    </div>
                  </>
                ) : (
                  <div style={{ color: '#888' }}>{'Sin productos'}</div>
                )}
              </div>

              <button onClick={handleNext} className='chevon_meta_next' aria-label="Next" disabled={products.length === 0}>
                <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 6L15 12L9 18" stroke="#517769" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="loading"><div className="spinner"></div></div>
      ) : <div /> }
    </div>
  );
}

export default EditorMetas;
